import styled from 'styled-components';

import { breakpoints } from '~/src/features/_layout/Header/types';

export const Logo = styled.div`
  display: block;
  margin: auto 17px auto 0;

  @media (max-width: ${breakpoints.sMobile}) {
      margin-right: 14px;
  }
`;
